
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/company",
      function () {
        return require("private-next-pages/dashboard/company/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/company"])
      });
    }
  